<template>
  <CollapseRadio
    v-if="groupId"
    :id="id"
    :tag="tag"
    :initial-active="initialActive"
  >
    <slot />
  </CollapseRadio>
  <CollapseCheckbox v-else :id="id" :tag="tag" :initial-active="initialActive">
    <slot />
  </CollapseCheckbox>
</template>

<script lang="ts" setup>
withDefaults(
  defineProps<{
    id: string
    tag?: keyof HTMLElementTagNameMap
    initialActive?: boolean
  }>(),
  {
    tag: 'div'
  }
)

const groupId = inject<string | null>('group-id', null)
</script>

<style lang="scss" scoped>
:deep(.input:checked ~ .collapse-content) {
  grid-template-rows: 1fr;
  opacity: 1;
}
</style>
